// extracted by mini-css-extract-plugin
module.exports = {"soldList":"SoldList_soldList__2NMCy","setContainer":"SoldList_setContainer__2UqD9"};